@if (kpiListe$ | async; as kpiListe) {
  <table class="hb-table hb-table--fluid" summary="Tabellen viser nøkkeltall for {{ hentValgtFilter() }}">
    <thead>
      <tr></tr>
    </thead>
    <tbody>
      @for (kpi of kpiListe; track kpi) {
        <tr>
          <td>{{ kpi.header }}</td>
          <td class="hb-text--no-wrap hb-text--base">
            @if (kpi.value) {
              {{ kpi.value.qText }}
            }

            @if (laster$ | async; as laster) {
              <span class="hb-spinner hb-spinner--tekst-justert" role="alert">
                <span class="hb-screenreader-only">{{ " " }}Vennligst vent, laster nøkkeltall.</span>
              </span>
              <span class="hb-spinner-tekst">{{ " " }}Laster nøkkeltall...</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
